import LegalPageLayout from "@/components/landing/LegalPageLayout";

const AmlPolicy = () => (
  <LegalPageLayout title="AML / KYC Policy" lastUpdated="January 15, 2026">
    <section>
      <h2>1. Decentralized Service</h2>
      <p>
        Trust Wallet Card operates as a fully decentralized service. We do not collect, store, or process any personal identification data. There are no AML (Anti-Money Laundering) or KYC (Know Your Customer) verification procedures required to use our services.
      </p>
    </section>

    <section>
      <h2>2. No Identity Verification</h2>
      <p>
        As a decentralized platform, we do not require any form of identity verification. Users are not asked to provide government-issued IDs, proof of address, selfies, or any other personal documents. Access to our services is granted solely through a connected cryptocurrency wallet.
      </p>
    </section>

    <section>
      <h2>3. No Transaction Monitoring</h2>
      <p>
        We do not monitor, track, or analyze individual user transactions. All transactions are processed on-chain through smart contracts and are publicly verifiable on the respective blockchain networks. We do not perform sanctions screening or flag transactions.
      </p>
    </section>

    <section>
      <h2>4. User Responsibility</h2>
      <p>
        Users are solely responsible for ensuring that their use of the platform complies with the laws and regulations applicable in their jurisdiction. By using our services, users acknowledge that they are acting in accordance with their local legal requirements.
      </p>
    </section>

    <section>
      <h2>5. No Data Retention</h2>
      <p>
        Since no personal data is collected, there is no user data stored on our servers. Wallet addresses used to interact with the platform are publicly available on the blockchain and are not linked to any personal identity within our system.
      </p>
    </section>

    <section>
      <h2>6. Why No KYC/AML?</h2>
      <p>
        Our decentralized architecture means there is no central authority controlling user accounts or funds. Smart contracts execute transactions autonomously, and users maintain full custody of their assets at all times. This model eliminates the need for traditional compliance procedures while preserving user privacy and financial sovereignty.
      </p>
    </section>
  </LegalPageLayout>
);

export default AmlPolicy;
